import React from 'react';
import { I18n } from '@aws-amplify/core';

import type { StrainIndexReport } from '@/types/StrainIndex';

import { RiskColumn } from './RiskColumn';
import { buildStrainIndexFactors, toScoreText } from './utils';
import { SectionTitle } from '../styles';
import { FactorRow, Half, HeaderRow, Label, RiskBody, SideCell, Table } from './styles';

interface StrainIndexTableProps {
	strainIndex: StrainIndexReport;
}

export function StrainIndexTable({ strainIndex }: Readonly<StrainIndexTableProps>): JSX.Element {
	const factors = buildStrainIndexFactors(strainIndex);

	return (
		<div>
			<SectionTitle>{I18n.get('Revised Strain Index (RSI)')}</SectionTitle>
			<Table>
				<Half>
					<HeaderRow>
						<Label />
						<SideCell>{I18n.get('Left')}</SideCell>
						<SideCell>{I18n.get('Right')}</SideCell>
					</HeaderRow>
					{factors.map((factor) => (
						<FactorRow key={factor.label}>
							<Label>{factor.label}</Label>
							<SideCell>{toScoreText(factor.left)}</SideCell>
							<SideCell>{toScoreText(factor.right)}</SideCell>
						</FactorRow>
					))}
				</Half>
				<Half>
					<HeaderRow>
						<Label>{I18n.get('Risk range')}</Label>
					</HeaderRow>
					<RiskBody>
						<RiskColumn
							side={I18n.get('Left')}
							score={strainIndex.score_left_rsi}
							risk={strainIndex.left_risk}
						/>
						<RiskColumn
							side={I18n.get('Right')}
							score={strainIndex.score_right_rsi}
							risk={strainIndex.right_risk}
						/>
					</RiskBody>
				</Half>
			</Table>
		</div>
	);
}
